import {
  CAN_LEAVE,
  CLOSE_DIALOGUE,
  LEAVE_DIALOGUE,
  OPEN_DIALOGUE,
  SAVE_DIALOGUE,
  START_SAVE,
} from './constants';

import { Record } from 'immutable';

const initialState = new (Record({
  canLeave: false,
  disabled: false,
  open: false,
  pathname: null,
  search: null,
  state: null,
  hash: null,
  saving: false,
}))();

function leaveDialogueReducer(state = initialState, action = undefined) {
  switch (action.type) {
    case OPEN_DIALOGUE: {
      const { pathname, search, state: locationState, hash } = action.payload;
      return state
        .set('open', true)
        .set('pathname', pathname)
        .set('search', search)
        .set('state', locationState)
        .set('hash', hash)
        .set('canLeave', false)
        .set('disabled', false)
        .set('saving', false);
    }
    case CLOSE_DIALOGUE:
      return state
        .set('open', false)
        .set('pathname', null)
        .set('search', null)
        .set('state', null)
        .set('hash', null)
        .set('canLeave', false)
        .set('disabled', false);
    case LEAVE_DIALOGUE:
    case CAN_LEAVE:
      return state.set('canLeave', true);
    case `${SAVE_DIALOGUE}_START`:
      return state.set('disabled', true);
    case `${SAVE_DIALOGUE}_ERROR`:
      return state.set('disabled', false).set('open', false);
    case START_SAVE:
      return state.set('saving', true);
    default:
      return state;
  }
}

export default leaveDialogueReducer;
